import { Bell, Settings, Search, SlidersHorizontal } from "lucide-react";
import { useState } from "react";
import trackConcreteLogo from "figma:asset/de4b40c223fb215bf1fcd10f330c3ad2cff8ac23.png";
import { ImageWithFallback } from "./figma/ImageWithFallback";

interface TopNavigationBarProps {
  notificationCount?: number;
  onNotificationClick?: () => void;
  title?: string;
  showBackButton?: boolean;
  onBackClick?: () => void;
}

export default function TopNavigationBar({
  notificationCount = 0,
  onNotificationClick,
  title,
  showBackButton = false,
  onBackClick,
}: TopNavigationBarProps) {
  const [searchQuery, setSearchQuery] = useState("");

  return (
    <div className="sticky top-0 z-50 bg-white">
      {/* Responsive Container */}
      <div className="w-full max-w-md sm:max-w-xl md:max-w-2xl lg:max-w-4xl xl:max-w-6xl mx-auto">
        {/* Top Header Section */}
        <div className="px-4 pt-3 pb-3 flex items-center justify-between">
          {/* Left Section - Logo & Title */}
          <div className="flex items-center gap-3">
            <div
              className="w-10 h-10 rounded-full flex items-center justify-center bg-[#00315c]"
            >
              <ImageWithFallback
                src={trackConcreteLogo}
                alt="Track Concrete"
                className="w-6 h-6 object-contain"
                style={{ filter: "brightness(0) invert(1)" }}
              />
            </div>
            <div>
              <div
                style={{
                  fontSize: "16px",
                  fontWeight: "600",
                  color: "#00315c",
                }}
              >
                Track Concrete
              </div>
              
            </div>
          </div>

          {/* Right Section - Action Buttons */}
          <div className="flex items-center gap-2">
            {/* Notification Button */}
            <button
              className="relative p-2 rounded-full hover:bg-gray-100 transition-all"
              onClick={onNotificationClick}
            >
              <Bell size={22} style={{ color: "#00315c" }} />
              {notificationCount > 0 && (
                <div
                  className="absolute w-2 h-2 rounded-full"
                  style={{
                    backgroundColor: "#FF6B6B",
                    top: "6px",
                    right: "6px",
                  }}
                />
              )}
            </button>

            {/* Profile/Settings Button */}
            
          </div>
        </div>

        {/* Search Bar Section */}
        <div className="px-4 pb-3">
          <div
            className="rounded-3xl px-4 py-3 flex items-center gap-2 focus-within:ring-2 focus-within:ring-[#00315c] transition-all"
            style={{ backgroundColor: "#F6F7F9" }}
          >
            <Search size={20} className="text-gray-400" />
            <input
              type="text"
              placeholder="Search batches, tests, reports..."
              className="flex-1 bg-transparent outline-none text-sm"
              style={{ color: "#00315c" }}
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            <button className="p-1.5 rounded-lg hover:bg-white transition-all">
              <SlidersHorizontal size={18} style={{ color: "#00315c" }} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
